module.exports = __webpack_public_path__ + "img/17849_S.3c479baf.png";